import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";

import Box from "@mui/material/Box";
import Logo from "../../assets/logoStudioPBADS.png";

import { useTranslation } from "react-i18next";
import { login } from "../../reducers/user/userThunks";
import LoginForm from "./LoginForm";
import RecoveryForm from "./RecoveryForm";
import SubscribeForm from "./SubscribeForm";
import { useEffect } from "react";
import { Copyright } from "../../helpers";
import { useLocation, useNavigate } from "react-router-dom";

const PREFIX = "AuthForms";

const classes = {
  root: `${PREFIX}-root`,
  paper: `${PREFIX}-paper`,
  logo: `${PREFIX}-logo`,
};

const Root = styled("div")(({ theme }) => {
  return {
    [`& .${classes.root}`]: {
      height: "100vh",
    },

    [`&.${classes.paper}`]: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      maxWidth: "350px",
      width: "100%",
      marginBottom: "2rem",
      margin: "0 auto",
      paddingBottom: "2rem",
    },
    [`& .${classes.logo}`]: {
      backgroundColor: "transparent",
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
      backgroundPosition: "center",
      maxHeight: "200px",
      width: "100%",
      marginTop: "10px",
      [theme.breakpoints.only("xs")]: {
        display: "block",
      },
    },
  };
});

export default function AuthForms(props) {
  const { enqueueSnackbar } = useSnackbar();
  const history = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [authMode, setAuthMode] = useState(props.mode);

  useEffect(() => {
    if (authMode === "recovery") props.setIsRecovery(true);
    else props.setIsRecovery(false);
  }, [authMode]);

  const handleLogin = async (usernameLogin, passwordLogin) => {
    try {
      const thunk = await dispatch(
        login({ login: usernameLogin, password: passwordLogin })
      );
      if (thunk.meta.requestStatus === "rejected")
        throw new Error("login error");
      const { from } = location.state || {
        from: {
          pathname:
            props.origin === "purchaseGeoloc"
              ? `/purchase-geoloc/${props.exparienceID}`
              : "/",
        },
      };
      enqueueSnackbar(t("toasts.loginSuccess"), { variant: "success" });
      props.handleCloseModal();
      if (props.origin === "purchaseGeoloc") {
        props.setLoginModal(false);
      }
      history(from);
    } catch (err) {
      enqueueSnackbar(t("toasts.loginFailed"), { variant: "error" });
    }
  };

  return (
    <Root className={classes.paper}>
      <img src={Logo} alt="artDesignStory logo" className={classes.logo} />
      {authMode === "login" ? (
        <LoginForm
          handleLogin={handleLogin}
          authMode={authMode}
          setAuthMode={setAuthMode}
          handleCloseModal={props.handleCloseModal}
        />
      ) : authMode === "recovery" ? (
        <RecoveryForm
          authMode={authMode}
          setAuthMode={setAuthMode}
          handleCloseModal={props.handleCloseModal}
        />
      ) : authMode === "register" ? (
        <SubscribeForm
          authMode={authMode}
          handleLogin={handleLogin}
          setAuthMode={setAuthMode}
          handleCloseModal={props.handleCloseModal}
        />
      ) : null}
      <Box mt={5}>
        <Copyright />
      </Box>
    </Root>
  );
}
